import * as yup from "yup";

export const defaultFormValues = {
  apiKeyType: "",
  key: "",
};

export const schema = yup.object().shape({
  apiKeyType: yup.string().required("Api Key Type is required"),
  key: yup.string().required("Key is required"),
});

export const KeyTypesMap = [
  {
    label: "Voucher Box",
    value: "VOUCHER_BOX",
    description: "Platform to manage gift cards, and vouchers.",
  },
];
